import { makeEnum } from "utils/enum.util";

export const Preferences = makeEnum(["hide-quick-search", "hide-referral"]);
